/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from "react-intl";
import { KTIcon } from "../../../helpers";
import { AsideMenuItemWithSub } from "./AsideMenuItemWithSub";
import { AsideMenuItem } from "./AsideMenuItem";
import { useAppDispatch } from "../../../../app/redux/hooks";
import { logoutUser } from "../../../../app/redux/slices/user/userSlice";
import { CheckPermission } from "../../../../app/modules/customs/lib";

export function AsideMenuMain() {
  const intl = useIntl();

  const dispatch = useAppDispatch();

  return (
    <>
      <CheckPermission permissions={"menu-management"}>
        <AsideMenuItem to={"/dashboard"} icon={"home"} title={"خانه"} />
      </CheckPermission>
      {/* stadiumProfiles */}

      <CheckPermission
        permissions={["stadiumProfile_view", "stadiumProfile_create"]}
      >
        <AsideMenuItemWithSub
          to={"/stadiumProfiles"}
          title=" مدیریت ورزشگاه‌ "
          icon="note-2"
        >
          <AsideMenuItemWithSub
            to={"/stadiumProfiles"}
            title=" پروفایل ورزشگاه‌ "
            icon="note-2"
          >
            <CheckPermission permissions={"stadiumProfile_view"}>
              <AsideMenuItem
                to={"/stadiumProfiles/profiles-list"}
                title={" مدیریت پروفایل‌ها"}
                hasBullet={true}
              />
            </CheckPermission>

            <CheckPermission permissions={"stadiumProfile_create"}>
              <AsideMenuItem
                to="/stadiumProfiles/add-profile"
                title="پروفایل جدید"
                hasBullet={true}
              />
            </CheckPermission>
            {/* gate */}
          </AsideMenuItemWithSub>
          <CheckPermission
            permissions={["gate_device_view", "gate_device_create"]}
          >
            <AsideMenuItemWithSub
              to={"/teams"}
              title="مدیریت گیت‌ها"
              icon="note-2"
            >
              <CheckPermission permissions={"gate_device_create"}>
                <AsideMenuItem
                  to={"/gate/gate-list"}
                  title={"لیست گیت‌ها"}
                  hasBullet={true}
                />
              </CheckPermission>
              <CheckPermission permissions={"gate_device_create"}>
                <AsideMenuItem
                  to="/gate/add-gate"
                  title="ایجاد گیت جدید"
                  hasBullet={true}
                />
              </CheckPermission>
            </AsideMenuItemWithSub>
          </CheckPermission>
        </AsideMenuItemWithSub>
      </CheckPermission>

      {/* match */}
      <CheckPermission permissions={["ticketTeam_create", "ticketTeam_view"]}>
        <AsideMenuItemWithSub to={"/match"} title="مدیریت بازی" icon="note-2">
          <CheckPermission
            permissions={["ticketTeam_create", "ticketTeam_view"]}
          >
            <AsideMenuItemWithSub to={"/teams"} title="تیم‌ها" icon="note-2">
              <CheckPermission permissions={"ticketTeam_view"}>
                <AsideMenuItem
                  to={"/teams/teams-list"}
                  title={"لیست تیم ها"}
                  hasBullet={true}
                />
              </CheckPermission>
              <CheckPermission permissions={"ticketTeam_create"}>
                <AsideMenuItem
                  to="/teams/add-team"
                  title="ایجاد تیم جدید"
                  hasBullet={true}
                />
              </CheckPermission>
            </AsideMenuItemWithSub>
          </CheckPermission>
          {/* league */}
          <CheckPermission permissions={"ticketLeague_view"}>
            <AsideMenuItemWithSub to={"/leagues"} title="لیگ‌ها " icon="note-2">
              <CheckPermission permissions={"ticketLeague_view"}>
                <AsideMenuItem
                  to={"/leagues/leagues-list"}
                  title={" لیست لیگ‌ها"}
                  hasBullet={true}
                />
              </CheckPermission>
              <CheckPermission permissions={"ticketLeague_create"}>
                <AsideMenuItem
                  to="/leagues/add-league"
                  title="لیگ جدید"
                  hasBullet={true}
                />
              </CheckPermission>
            </AsideMenuItemWithSub>
          </CheckPermission>
          {/* matches */}
          <CheckPermission
            permissions={["ticketMatch_create", "ticketMatch_view"]}
          >
            <AsideMenuItemWithSub to={"/matches"} title="بازی‌ها" icon="note-2">
              <CheckPermission permissions={"ticketMatch_view"}>
                <AsideMenuItem
                  to={"/matches/matches-list"}
                  title={" لیست بازی‌ها"}
                  hasBullet={true}
                />
              </CheckPermission>
              <CheckPermission permissions={"ticketMatch_create"}>
                <AsideMenuItem
                  to="/matches/add-match"
                  title="بازی جدید"
                  hasBullet={true}
                />
              </CheckPermission>
            </AsideMenuItemWithSub>
          </CheckPermission>
        </AsideMenuItemWithSub>
      </CheckPermission>

      {/* ticketInPerson */}
      <CheckPermission
        permissions={[
          "ticket_view",
          "ticket_create",
          "ticketSpecial_view",
          "ticketSpecial_create",
        ]}
      >
        <AsideMenuItemWithSub
          to={"/ticketInPerson"}
          title="مدیریت بلیت ها  "
          icon="note-2"
        >
          <CheckPermission permissions={"ticket_view"}>
            <AsideMenuItemWithSub
              to={"/ticket-in-person"}
              title="بلیت حضوری"
              icon="note-2"
            >
              <CheckPermission permissions={"ticket_view"}>
                <AsideMenuItem
                  to={"/ticket-in-person/ticket"}
                  title={"لیست بلیت های صادرشده"}
                  hasBullet={true}
                />
              </CheckPermission>
              <CheckPermission permissions={"ticket_create"}>
                <AsideMenuItem
                  to={"/ticket-in-person/add-ticket"}
                  title={"صدور بلیط حضوری"}
                  hasBullet={true}
                />
              </CheckPermission>
            </AsideMenuItemWithSub>
          </CheckPermission>

          {/* ticket-in-special */}
          <CheckPermission
            permissions={[
              "ticket_view",
              "ticketSpecial_view",
              "ticketSpecial_create",
            ]}
          >
            <AsideMenuItemWithSub
              to={"/ticket-in-special"}
              title="بلیت ویژه "
              icon="note-2"
            >
              <CheckPermission
                permissions={["ticket_view", "ticketSpecial_view"]}
              >
                <AsideMenuItem
                  to={"/ticket-in-special/ticket"}
                  title={" لیست بلیت های ویژه"}
                  hasBullet={true}
                />
              </CheckPermission>
              <CheckPermission
                permissions={["ticket_view", "ticketSpecial_create"]}
              >
                <AsideMenuItem
                  to={"/ticket-in-special/add-ticket-special"}
                  title=" صدور بلیت ویژه"
                  hasBullet={true}
                />
              </CheckPermission>
            </AsideMenuItemWithSub>
          </CheckPermission>
        </AsideMenuItemWithSub>
      </CheckPermission>

      {/* report */}
      <CheckPermission permissions={"report_view"}>
        <AsideMenuItemWithSub to={"/reports"} title="گزارشات" icon="note-2">
          <CheckPermission permissions={["report_view"]}>
            <AsideMenuItem
              to={"/reports/finished-matches"}
              title={"گزارش بازی"}
              hasBullet={true}
            />
            <AsideMenuItem
              to={"/reports/women-fan-card"}
              title={"گزارش کارت هواداری بانوان "}
              hasBullet={true}
            />
            <AsideMenuItem
              to={"/reports/province-report-list"}
              title={"گزارش تفکیک استان ها"}
              hasBullet={true}
            />
            <AsideMenuItem
              to={"/reports/fans-list"}
              title={"گزارش هواداران"}
              hasBullet={true}
            />
            <AsideMenuItem
              to={"/reports/fan-users-list"}
              title={"گزارش کاربران "}
              hasBullet={true}
            />
          </CheckPermission>
        </AsideMenuItemWithSub>
      </CheckPermission>

      {/* {report special} */}
      <CheckPermission
        permissions={[
          "report_level_1_view",
          "report_level_2_view",
          "report_level_3_view",
          "report_level_4_view",
          "report_level_5_view",
        ]}
      >
        <AsideMenuItemWithSub
          to={"/reports-special"}
          title=" گزارشات ویژه"
          icon="note-2"
        >
          <CheckPermission
            permissions={[
              "report_level_1_view",
              "report_level_2_view",
              "report_level_3_view",
              "report_level_4_view",
              "report_level_5_view",
            ]}
          >
            <AsideMenuItemWithSub
              to={"/reports-special"}
              title=" گزارشات بازی"
              icon="note-2"
            >
              <CheckPermission
                permissions={[
                  "report_level_1_view",
                  "report_level_2_view",
                  "report_level_3_view",
                  "report_level_4_view",
                  "report_level_5_view",
                ]}
              >
                <AsideMenuItem
                  to={"/reports-special/fan-report-list-per-match"}
                  title={"آمار فروش"}
                  hasBullet={true}
                />
                <AsideMenuItem
                  to={"/reports-special/province-reportSpecial-List"}
                  title={"آمار استان"}
                  hasBullet={true}
                />
              </CheckPermission>
              <CheckPermission
                permissions={[
                  "report_level_2_view",
                  "report_level_3_view",
                  "report_level_4_view",
                  "report_level_5_view",
                ]}
              >
                <AsideMenuItem
                  to={"/reports-special/fan-report-attendes-all"}
                  title={"آمار هوادار"}
                  hasBullet={true}
                />
              </CheckPermission>
            </AsideMenuItemWithSub>
            <CheckPermission
              permissions={[
                "report_level_3_view",
                "report_level_5_view",
                "report_level_4_view",
              ]}
            >
              <AsideMenuItem
                to={"/reports-special/reportspecial-women-fan-card"}
                title={"گزارش کارت هواداری بانوان "}
                icon="note-2"
              />
            </CheckPermission>

            <CheckPermission
              permissions={["report_level_5_view", "report_level_4_view"]}
            >
              <AsideMenuItem
                to={"/reports-special/women-fan-cardList-detalis"}
                title={"جزئیات کارت هواداری بانوان"}
                icon="note-2"
              />
            </CheckPermission>

            <CheckPermission permissions={["report_level_5_view"]}>
              <AsideMenuItem
                to={"/reports-special/repoetfans-log-list"}
                title={"جستجولاگ"}
                icon="note-2"
              />
            </CheckPermission>
          </CheckPermission>
        </AsideMenuItemWithSub>
      </CheckPermission>

      <CheckPermission permissions={"menu-content"}>
        <AsideMenuItemWithSub
          to={"content"}
          title={"مدیریت محتوا"}
          icon={"book-open"}
        >
          <AsideMenuItem
            to={"/file-manager/file/files/"}
            icon={"folder"}
            title={"مدیریت فایل"}
          />
        </AsideMenuItemWithSub>
      </CheckPermission>
      {/* operator  */}

      <CheckPermission
        permissions={["organization_view", "organization_create"]}
      >
        <AsideMenuItemWithSub
          to={"/operator"}
          title="مدیریت کاربران"
          icon="abstract-26"
        >
          <CheckPermission permissions={["menu-management"]}>
            <AsideMenuItem
              to={"/operator/users"}
              title={"کارشناسان"}
              icon={"people"}
            />
            <AsideMenuItem
              to={"/operator/roles"}
              title={"نقش‌ها"}
              icon={"user-tick"}
            />
            <AsideMenuItem
              to={"/operator/accesses"}
              title={"دسترسی‌ها"}
              icon={"lock-2"}
            />
          </CheckPermission>

          {/* organization */}
          <CheckPermission permissions={"organization_view"}>
            <AsideMenuItemWithSub
              to={"/operator/organization"}
              title={"سازمان ها"}
              icon={"lock-2"}
            >
              <CheckPermission permissions={"organization_view"}>
                <AsideMenuItem
                  to={"/operator/organization-list"}
                  title={" لیست سازمان ها"}
                  icon={"lock-2"}
                />
              </CheckPermission>
              <CheckPermission permissions={"organization_create"}>
                <AsideMenuItem
                  to={"/operator/add-organization"}
                  title={" ایجاد سازمان"}
                  icon={"lock-2"}
                />
              </CheckPermission>
            </AsideMenuItemWithSub>
          </CheckPermission>

          {/* ticket-in-special */}
        </AsideMenuItemWithSub>
      </CheckPermission>
      <CheckPermission permissions={["fanCard_view"]}>
        <AsideMenuItemWithSub
          to={"/management-fan"}
          title="مدریت هواداران"
          icon="abstract-26"
        >
          <AsideMenuItem
            to={"/management-fan/list-women"}
            title={" کارت هواداری بانوان"}
            icon={"user-tick"}
          />
          <CheckPermission permissions={"fanCard_create"}>
            <AsideMenuItem
              to={"/management-fan/create-fan-card"}
              title={" صدور کارت هواداری"}
              icon={"user-tick"}
            />
          </CheckPermission>
          <AsideMenuItemWithSub
            to={"/management-fan"}
            title="  مدیریت قرعه کشی "
            icon="note-2"
          >
            <CheckPermission permissions={"lottery_view"}>
              <AsideMenuItem
                to={"/management-fan/lottery-list"}
                title={" لیست قرعه کشی"}
                hasBullet={true}
              />
            </CheckPermission>

            <CheckPermission permissions={"stadiumProfile_create"}>
              <AsideMenuItem
                to="/management-fan/add-lottery"
                title=" قرعه کشی جدید"
                hasBullet={true}
              />
            </CheckPermission>
            {/* gate */}
          </AsideMenuItemWithSub>
          {/* <CheckPermission permissions={"lottery_view"}>
            <AsideMenuItem
              to={"/management-fan/lottery"}
              title={"قرعه کشی"}
              icon={"user-tick"}
            />
          </CheckPermission> */}

        </AsideMenuItemWithSub>
      
      </CheckPermission>

      <div className="menu-item mt-auto">
        <button
          className="menu-link border-0 w-100 bg-transparent"
          onClick={() => dispatch(logoutUser())}
        >
          <span className="menu-icon">
            <KTIcon iconName="exit-right" className="fs-1 text-danger" />
          </span>
          <span className="menu-title text-danger">خروج</span>
        </button>
      </div>
    </>
  );
}
